import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import SettingsPage from '../partials/SettingsPage';
import LoadingSpinner from '../partials/LoadingSpinner';
import LoadingPlaceholder from '../partials/LoadingPlaceholder';
import PageHeader from "../partials/PageHeader";
import { Link, useNavigate } from "react-router-dom";

import { createSupplier } from '../../redux/actions/suppliers';
import { taxSettingsIndex } from '../../redux/actions/taxSettings';
import { paymentTermsIndex } from '../../redux/actions/paymentTerms';
import { paymentMethodsIndex } from '../../redux/actions/paymentMethods';


import { Button, Text, Panel, Input, Dropdown, H3, H4, Small, Box } from '@bigcommerce/big-design';
import { ArrowDropDownIcon, AddIcon } from '@bigcommerce/big-design-icons';


const NewSupplierForm = ({ payload, newSupplier, addSupplier, loadTaxSettings, loadPaymentTerms, loadPaymentMethods, taxSettings, paymentTerms, paymentMethods }) => {
  let navigate = useNavigate();

  const [submitted, setSubmitted] = useState(false);

  const [validAddress, setValidAddress] = useState(false);  
  const [validSupplier, setValidSupplier] = useState(false);
  const [validationErrors, setValidationErrors] = useState([]);

  const [supplierName, setSupplierName] = useState('');
  const [contactEmail, setContactEmail] = useState('');
  const [contactPhone, setContactPhone] = useState('');
  const [accountNumber, setAccountNumber] = useState('');
  const [phoneTollFree, setPhoneTollFree] = useState('');
  const [fax, setFax] = useState('');
  const [websiteAddress, setWebsiteAddress] = useState('');
  const [orderPortal, setOrderPortal] = useState('');
  const [supplierNotes, setSupplierNotes] = useState('');
  const [shippingDays, setShippingDays] = useState(null);

  const [taxSetting, setTaxSetting] = useState(null);
  const [paymentTerm, setPaymentTerm] = useState(null);
  const [paymentMethod, setPaymentMethod] = useState(null);

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [company, setCompany] = useState('');
  const [street1, setStreet1] = useState('');
  const [street2, setStreet2] = useState('');
  const [city, setCity] = useState('');
  const [zip, setZip] = useState('');
  const [country, setCountry] = useState('');
  const [state, setState] = useState('');

  useEffect(() => {
    loadTaxSettings(payload);
    loadPaymentTerms(payload);
    loadPaymentMethods(payload);
  }, []);

  useEffect(() => {
    if(newSupplier) { navigate(-1) };
  }, [newSupplier]);

  const addressJson = () => {
    return {
      'first_name': firstName,
      'last_name': lastName,
      'company': company,
      'street_1': street1,
      'street_2': street2,
      'city': city,
      'zip': zip,
      'country': country,
      'state': state
    }
  }

  const supplierJson = () => {
    return {
      'supplier_name': supplierName,
      'contact_email': contactEmail,
      'contact_phone': contactPhone,
      'account_number': accountNumber,
      'phone_toll_free': phoneTollFree,
      'fax': fax,
      'website_address': websiteAddress,
      'order_portal': orderPortal,
      'supplier_notes': supplierNotes,
      'tax_setting_id': taxSetting?.id,
      'payment_terms_id': paymentTerm?.id,
      'payment_method_id': paymentMethod?.id,
      'shipping_days': shippingDays,
    }
  }

  const validateAddress = () => {
    setValidAddress((firstName.length > 0) && (lastName.length > 0) && (street1.length > 0) && (city.length > 0) && (zip.length > 0) && (country.length > 0) && (state.length > 0));
  }

  const validateSupplier = () => {
    setValidSupplier(supplierName.length > 0);
  }

  const setFieldValue = (setField, event) => {
    let value = event.target.value;
    setField(value);
    validateSupplier();
  }

  const setDropdownValue = (setField, value) => {
    setField(value);
    validateSupplier();
  }

  const setAddressValue = (setField, event) => {
    let value = event.target.value;
    setField(value);
    validateAddress();
  }

  const taxSettingItems = () => {
    let items = [];

    taxSettings.taxSettings.map(taxSetting => 
      items.push(
        {
          content: taxSetting.tax_name,
          onItemClick: () => setDropdownValue(setTaxSetting, taxSetting),
          hash: taxSetting.id
        }
      )
    )

    return items;
  }

  const paymenTermsItems = () => {
    let items = [];

    paymentTerms.paymentTerms.map(paymentTerm => 
      items.push(
        {
          content: paymentTerm.term_name,
          onItemClick: () => setDropdownValue(setPaymentTerm, paymentTerm),
          hash: paymentTerm.id
        }
      )
    )

    return items;
  }

  const paymentMethodsItems = () => {
    let items = [];

    paymentMethods.paymentMethods.map(paymentMethod => 
      items.push(
        {
          content: paymentMethod.method_name,
          onItemClick: () => setDropdownValue(setPaymentMethod, paymentMethod),
          hash: paymentMethod.id
        }
      )
    )

    return items;
  }

  const handleSubmit = () => {
    setSubmitted(true);
    addSupplier(payload, supplierJson(), addressJson());
  }

  const description = () => {
    return(
      <>
        <Text>Fill out fields to describe a new supplier.</Text>
        <Text>Select default tax settings, payment terms and payment method from their respective dropdowns. If tax settings, payment terms or payment methods are missing, go to the <Link to="/settings">Settings page</Link> to update those options.</Text>
        <Text>Once the supplier's information has been filled out, click the "Add Supplier" button to submit this form and create the supplier.</Text>
        <Small>Have questions or need some help? Contact us at <a href="mailto:support@athousandapps.com">support@athousandapps.com</a></Small>
      </>
    )
  }

  return (
    <>
      <PageHeader stripeBackground='#5bc6cc' helpLink="bigcommerce/manage-suppliers/" />
      <SettingsPage title="New Supplier" description={description()}>
        <Panel>
          <H3>Supplier Details</H3>
          <Input required label="Supplier Name" placeholder="Supplier Name" id="supplier_name" type="text" value={supplierName} onChange={(e) => setFieldValue(setSupplierName, e)} />
          <Input label="Contact Email" placeholder="Contact Email" id="contact_email" type="text" value={contactEmail} onChange={(e) => setFieldValue(setContactEmail, e)} />
          <Input label="Contact Phone" placeholder="Contact Phone" id="contact_phone" type="text" value={contactPhone} onChange={(e) => setFieldValue(setContactPhone, e)} />
          <Input label="Account Number" placeholder="Account Number" id="account_number" type="text" value={accountNumber} onChange={(e) => setFieldValue(setAccountNumber, e)} />
          <Input label="Phone Toll Free" placeholder="Phone Toll Free" id="phone_toll_free" type="text" value={phoneTollFree} onChange={(e) => setFieldValue(setPhoneTollFree, e)} />
          <Input label="Fax" placeholder="Fax" id="fax" type="text" value={fax} onChange={(e) => setFieldValue(setFax, e)} />
          <Input label="Website Address" placeholder="Website Address" id="website_address" type="text" value={websiteAddress} onChange={(e) => setFieldValue(setWebsiteAddress, e)} />
          <Input label="Order Portal" placeholder="Order Portal" id="order_portal" type="text" value={orderPortal} onChange={(e) => setFieldValue(setOrderPortal, e)} />
          <Input label="Supplier Notes" placeholder="Supplier Notes" id="supplier_notes" type="text" value={supplierNotes} onChange={(e) => setFieldValue(setSupplierNotes, e)} />
        
          <Input label="Shipping Days" placeholder="Shipping Days" id="shipping_days" type="number" value={shippingDays} onChange={(e) => setFieldValue(setShippingDays, e)} />
        </Panel>
        <Panel>
          <H3>Supplier Payment and Taxes</H3>

          <div className="flex-container">
            <div className="flex-1">
              <H4>Default Tax Setting</H4>
              {taxSettings.status === 'success' && taxSettings.taxSettings.length > 0 &&
                <Dropdown
                  items={taxSettingItems()}
                  maxHeight={250}
                  placement="bottom-start"
                  toggle={<Button iconRight={<ArrowDropDownIcon />}>{taxSetting?.tax_name || "Select Default Tax Setting"}</Button>}
                />
              }
              { taxSettings.status !== 'success' &&
                <LoadingSpinner size="xxSmall" statusText="Loading tax settings" />
              }
              { taxSettings.status === 'success' && taxSettings.taxSettings.length === 0 &&
                <Box
                  backgroundColor="warning10"
                  border="box"
                  borderRadius="normal"
                  padding="medium"
                >
                  <div className="text-center">
                    <Text>No tax settings set. Create tax settings to see them in a dropdown here.</Text>
                    <Link to="/settings">
                      <Button iconLeft={<AddIcon />}>Update Settings</Button>
                    </Link>
                  </div>
                </Box>
              }
            </div>

            <div className="flex-1">
              <H4>Default Payment Terms</H4>
              { paymentTerms.status === 'success' && paymentTerms.paymentTerms.length > 0 &&
                <Dropdown
                  items={paymenTermsItems()}
                  maxHeight={250}
                  placement="bottom-start"
                  toggle={<Button iconRight={<ArrowDropDownIcon />}>{paymentTerm?.term_name || "Select Default Payment Terms"}</Button>}
                />
              }
              { paymentTerms.status !== 'success' &&
                <LoadingSpinner size="xxSmall" statusText="Loading payment terms" />
              }
              { paymentTerms.status === 'success' && paymentTerms.paymentTerms.length === 0 &&
                <Box
                  backgroundColor="warning10"
                  border="box"
                  borderRadius="normal"
                  padding="medium"
                >
                  <div className="text-center">
                    <Text>No payment terms set. Create payment terms to see them in a dropdown here.</Text>
                    <Link to="/settings">
                      <Button iconLeft={<AddIcon />}>Update Settings</Button>
                    </Link>
                  </div>
                </Box>
              }
            </div>

            <div className="flex-1">
              <H4>Default Payment Method</H4>
              { paymentMethods.status === 'success' && paymentMethods.paymentMethods.length > 0 &&
                <Dropdown
                  items={paymentMethodsItems()}
                  maxHeight={250}
                  placement="bottom-start"
                  toggle={<Button iconRight={<ArrowDropDownIcon />}>{paymentMethod?.method_name || "Select Default Payment Method"}</Button>}
                />
              }
              { paymentMethods.status !== 'success' &&
                <LoadingSpinner size="xxSmall" statusText="Loading payment methods" />
              }
              { paymentMethods.status === 'success' && paymentMethods.paymentMethods.length === 0 &&
                <Box
                  backgroundColor="warning10"
                  border="box"
                  borderRadius="normal"
                  padding="medium"
                >
                  <div className="text-center">
                    <Text>No payment methods set. Create payment methods to see them in a dropdown here.</Text>
                    <Link to="/settings">
                      <Button iconLeft={<AddIcon />}>Update Settings</Button>
                    </Link>
                  </div>
                </Box>
              }
            </div>
          </div>
        </Panel>
        <Panel>
          <H3>Supplier Address Details</H3>
          <Input required label="First Name" placeholder="First Name" id="first_name" type="text" value={firstName} onChange={(e) => setAddressValue(setFirstName, e)} />
          <Input required label="Last Name" placeholder="Last Name" id="last_name" type="text" value={lastName} onChange={(e) => setAddressValue(setLastName, e)} />
          <Input label="Company" placeholder="Company" id="company" type="text" value={company} onChange={(e) => setAddressValue(setCompany, e)} />
          <Input required label="Street 1" placeholder="Street 1" id="street_1" type="text" value={street1} onChange={(e) => setAddressValue(setStreet1, e)} />
          <Input label="Street 2" placeholder="Street 2" id="street_2" type="text" value={street2} onChange={(e) => setAddressValue(setStreet2, e)} />
          <Input required label="City" placeholder="City" id="city" type="text" value={city} onChange={(e) => setAddressValue(setCity, e)} />
          <Input required label="State/Province" placeholder="State/Province" id="state" type="text" value={state} onChange={(e) => setAddressValue(setState, e)} />
          <Input required label="Country" placeholder="Country" id="country" type="text" value={country} onChange={(e) => setAddressValue(setCountry, e)} />
          <Input required label="Zip/Postal Code" placeholder="Zip/Postal Code" id="zip" type="text" value={zip} onChange={(e) => setAddressValue(setZip, e)} />
        </Panel>

        <hr />

        <Button
          isLoading={submitted}
          disabled={!((firstName.length > 0) && (lastName.length > 0) && (street1.length > 0) && (city.length > 0) && (zip.length > 0) && (country.length > 0) && (state.length > 0)) || !(supplierName.length > 0) || submitted}
          onClick={() => handleSubmit()}
          iconLeft={<AddIcon />}
        >
          Add Supplier
        </Button>

      </SettingsPage>
    </>
  )

}



const mapStateToProps = state => ({
  newSupplier: state.suppliers.newSupplier,
  taxSettings: state.taxSettings,
  paymentTerms: state.paymentTerms,
  paymentMethods: state.paymentMethods,
});

const mapDispatchToProps = (dispatch) => ({
  addSupplier: (payload, supplier, address) => dispatch(createSupplier(payload, supplier, address)),
  loadTaxSettings: (payload) => dispatch(taxSettingsIndex(payload)),
  loadPaymentTerms: (payload) => dispatch(paymentTermsIndex(payload)),
  loadPaymentMethods: (payload) => dispatch(paymentMethodsIndex(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NewSupplierForm);